function triggerLogoAnimation() {
  const brand = document.querySelector<HTMLElement>(".navbar-brand");
  if (!brand) return;

  const bubbles = brand.querySelectorAll(
    "#logo-bubble-1, #logo-bubble-2, #logo-bubble-3, #logo-bubble-4",
  );

  brand.classList.remove("play");

  bubbles.forEach((bubble, i) => {
    const el = bubble as HTMLElement;
    const randomOffset = (Math.random() - 0.5) * 0.1;
    el.style.animationDelay = `${Math.max(0, i * 0.12 + randomOffset)}s`;
    el.style.animationDuration = `${0.5 + Math.random() * 0.5}s`;
  });

  void brand.offsetWidth;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      brand.classList.add("play");
    });
  });
}

// `main.js` is enqueued in the footer, so on fast cached loads
// DOMContentLoaded may have already fired by the time this runs.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", triggerLogoAnimation);
} else {
  triggerLogoAnimation();
}

// Handles bfcache restores (back/forward nav)
window.addEventListener("pageshow", (e) => {
  if (e.persisted) triggerLogoAnimation();
});
